/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-08 10:53:57
 */
export default [
  {
    path: '/app',
    name: 'application',
    component: () => import('@/views/onside-staff/pc-result/Warpper.vue'),
    redirect: '/result',
    hidden: false,
    meta: {
      title: '现场控制',
      icon: 'fa fa-star iconTitle',
      role: ['scene_control'],
      level: 1
    },
    children: [
      {
        path: '/result',
        name: 'result',
        hidden: false,
        component: () => import('@/views/onside-staff/pc-result'),
        meta: {
          title: '现场控制',
          icon: 'fa fa-star iconTitle',
          role: ['scene_control'],
          level: 1
        }
      }
    ]
  },
  {
    path: '/app',
    name: 'application',
    component: () => import('@/views/onside-staff/Application.vue'),
    redirect: '/coordinate',
    hidden: false,
    meta: {
      title: '现场协调',
      icon: 'fa fa-star iconTitle',
      role: ['scene_scheduling'],
      level: 1
    },
    children: [
      {
        path: '/coordinate',
        name: 'coordinate',
        hidden: false,
        component: () => import('@/views/onside-staff/result/Result.vue'),
        meta: {
          title: '现场协调',
          icon: 'fa fa-star iconTitle',
          role: ['scene_scheduling'],
          level: 1,
          // 仅现场协调页允许手机窄屏直接进入；其他页面继续沿用父布局的横屏提示策略。
          mobileSupported: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/onside-staff/index.js